module.exports = __webpack_public_path__ + "logo.png?2a4fcd4c0ab7c3dec6c09fa4883305f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 69
// module chunks = 0